module.exports = __webpack_public_path__ + "img/Steve.f3d8063a.jpg";